import Vue from "vue";
import VueRouter from "vue-router";
import Main from '@/components/Main'

Vue.use(VueRouter);

const router = new VueRouter({
    routes: 
    [{
        path: '/#/',
		component: Main,
        children:[
        {
            path: "/im",
            name: "岱恩语培",
            component: resolve => require(["@/views/im.vue"], resolve)
        },
        {
            path: "/404",
            name: "岱恩语培",
            component: resolve => require(["@/views/404.vue"], resolve)
        },     
		{
		    path: "/middle",
		    name: "岱恩语培",
		    component: resolve => require(["@/views/middle.vue"], resolve)
		}
    ]
}]
});

router.beforeEach(function(to, from, next) {
    document.title = to.name;
    if (to.path === "/") {
        router.replace({
            path: "/404"
        });
        next();
    }
    next();
  
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js